import { person } from './helper/ValidatorRules'

const personValidator = {
  getMessage: () => 'Sorry, only letters, and symbols (. - \') are allowed.',
  validate: value => {
    return {
      valid: person(value),
      data: {
        required: true
      }
    }
  }
}

export default personValidator
